module.exports = __webpack_public_path__ + "static/media/ico-event-location.378600c1.svg";